<h1 mat-dialog-title>Modify user profile successful!!</h1>
User : {{data.last_name}} {{data.first_name}}
<div mat-dialog-content>
  <p>Press OK to close!</p>
 
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">OK</button> 
</div>
